import React, { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import { BackButton } from './back-button';

interface Props {
    children: ReactNode;
    redirect?: string;
}

export const WrappedWithBackButton = (props: Props) => {
    return (
        <Box>
            <Stack>
                <BackButton redirect={props.redirect} />
            </Stack>
            {props.children}
        </Box>
    );
};
